import { useEffect, useState } from 'react';
import { apiFetchRaw } from '../api/client';

export function AgentEvidence({ media, requestId }: { media: { id: string; kind: string; transcript?: string; error?: string }; requestId: string }) {
  const [url, setUrl] = useState(''); const [error, setError] = useState('');
  useEffect(() => { let active = true; let objectUrl = '';
    apiFetchRaw(`/api/v1/conversations/media/${encodeURIComponent(media.id)}?request_id=${encodeURIComponent(requestId)}`).then(async response => {
      if (!response.ok) throw new Error('Originale non disponibile');
      objectUrl = URL.createObjectURL(await response.blob()); if (active) setUrl(objectUrl); else URL.revokeObjectURL(objectUrl);
    }).catch(e => { if (active) setError(String(e)); });
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [media.id, requestId]);
  return <div>{url && (media.kind === 'audio' ? <audio style={{ maxWidth: '100%' }} controls src={url} /> : <a href={url} target="_blank" rel="noreferrer"><img style={{ maxWidth: '100%', maxHeight: 240 }} src={url} alt="Foto della segnalazione" /></a>)}{media.transcript && <p>{media.transcript}</p>}{(media.error || error) && <p role="alert">{media.error || error}</p>}</div>;
}
